import { Dropdown, type MenuProps } from "antd";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import localStorageKey from "../../../../../enumerations/localStorageKey";
import { useGetLangList } from "../../../../../hooks/Lang/lang.hooks";
import { pushGtag } from "../../../../../plugins/gtagFunction";
import styles from "./style.module.scss";
import "./style.scss";

const LangSelector = () => {
  const { i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(i18n.language);
  const [langListItems, setLangListItems] = useState<MenuProps["items"]>([]);
  const { data } = useGetLangList({});

  const renderNowLang = () => {
    if (!selectedKeys) return "";
    const found: any = langListItems?.find(
      (item) => item?.key === selectedKeys
    );
    return (
      <img
        style={{ width: 24 }}
        src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/langs/${
          found?.key ||
          window.localStorage.getItem(localStorageKey.DEFAULT_LANG)
        }.png`}
        alt={`lang-${found?.key}`}
      />
    );
  };

  useEffect(() => {
    if (data) {
      const items: MenuProps["items"] = [];
      data?.map(
        (langItem: {
          id: number;
          lang_code: string;
          language: string;
          name: string;
        }) => items.push({ label: langItem.name, key: langItem.language })
      );
      setLangListItems(items);
    }
  }, [data]);

  return (
    <Dropdown
      menu={{
        items: langListItems,
        onClick: (e) => {
          setSelectedKeys(e.key);
          i18n
            .changeLanguage(e.key)
            .then(() => {
              window.localStorage.setItem(localStorageKey.DEFAULT_LANG, e.key);
            })
            .then(() => window.location.reload())
            .catch((err) => {
              if (err) return console.log("something went wrong loading", err);
            });
          pushGtag({
            event: "lang_change",
            lang: e.key,
          });
        },
        multiple: false,
        selectedKeys: [selectedKeys],
        className: "lang-selector-dropdown-menu",
      }}
      // trigger={["click"]}
      trigger={["click", "hover"]}
      onOpenChange={(open) => {
        setDropdownOpen(open);
      }}
      overlayStyle={{ minWidth: "216px" }}
    >
      <div className={styles.langSelector}>
        <div>{renderNowLang()}</div>
      </div>
    </Dropdown>
  );
};

export default LangSelector;
